<template>
  <div class="bodycontent">
    <div class="page_title">
      通用设置
    </div>
    <div class="page_form">
      <el-form :model="formData" size="small" label-width="120px">
        <el-form-item label="优惠设置">
          <el-checkbox-group v-model="coupon">
            <el-checkbox v-for="item in type_options" :key="item.id" :label="item.name"></el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="折扣设置">
          <el-checkbox-group v-model="discount">
            <el-checkbox v-for="item in type_options" :key="item.id" :label="item.name"></el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="不享受优惠时间(最高优先级)">
          <el-radio-group v-model="periodType">
            <el-radio label="0" class="dblock">
              <span class="radio_name">每天</span>
              <el-time-picker 
                v-model="dayTimeValue[0]" 
                :disabled="periodType != '0'"
                class="time_picker_box"
                format="HH:mm"
                value-format="HH:mm"
                arrow-control
                size="small"
                style="width:100px"
                ></el-time-picker>
              至
              <el-time-picker 
                v-model="dayTimeValue[1]" 
                :disabled="periodType != '0'"
                class="time_picker_box"
                format="HH:mm"
                value-format="HH:mm"
                arrow-control
                size="small"
                style="width:100px"
                ></el-time-picker>
            </el-radio>
            <el-radio label="1" class="dblock">
              <span class="radio_name">每月</span>
              <el-select :disabled="periodType != '1'" v-model="monthDayValue" multiple collapse-tags placeholder="请选择" size="small" style="width:120px">
                <el-option
                  v-for="item in monthOptions"
                  :key="item"
                  :label="item"
                  :value="item">
                </el-option>
              </el-select>日
              <el-time-picker 
                v-model="monthTimeValue[0]" 
                :disabled="periodType != '1'"
                class="time_picker_box"
                format="HH:mm"
                value-format="HH:mm"
                arrow-control
                size="small"
                style="width:100px"
                ></el-time-picker>
              至
              <el-time-picker 
                v-model="monthTimeValue[1]" 
                :disabled="periodType != '1'"
                class="time_picker_box"
                format="HH:mm"
                value-format="HH:mm"
                arrow-control
                size="small"
                style="width:100px"
                ></el-time-picker>
            </el-radio>
            <el-radio label="2" class="dblock">
              <span class="radio_name">每周</span>
              <el-checkbox-group v-model="weekDayValue" size="small" class="week_select" :disabled="periodType != '2'">
                <el-checkbox-button v-for="item in weekOptions" :label="item.value" :key="item.value">{{item.name}}</el-checkbox-button>
              </el-checkbox-group>
              <el-time-picker 
                v-model="weekTimeValue[0]" 
                :disabled="periodType != '2'"
                class="time_picker_box"
                format="HH:mm"
                value-format="HH:mm"
                arrow-control
                size="small"
                style="width:100px"
                ></el-time-picker>
              至
              <el-time-picker 
                v-model="weekTimeValue[1]" 
                :disabled="periodType != '2'"
                class="time_picker_box"
                format="HH:mm"
                value-format="HH:mm"
                arrow-control
                size="small"
                style="width:100px"
                ></el-time-picker>
            </el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
    </div>
    <div class="save_button">
      <el-button size="small" type="primary" @click="save()">确定</el-button>
    </div>
  </div>
</template>
<script>
// import { getFamily, setFamily } from "@/api/vip"
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  data(){
    return{
      formData:{},
      coupon: [], // 优惠设置
      discount: [], //选择的折扣设置
      type_options: [
        {id:"1",name:"现金"},
        {id:"2",name:"余额"},
        {id:"3",name:"加油卡"},
      ], //优惠设置选择项
      periodType: "0", // 时间类型
      dayTimeValue: ["00:00","23:59"], //每天重复
      monthDayValue: [], //每月重复 日
      monthTimeValue: ["00:00","23:59"], //每月重复 时间
      monthOptions: [], //每月重复 日 选择项
      weekDayValue: [], //每周重复 日
      weekTimeValue: ["00:00","23:59"], //每周重复 时间
      weekOptions:[
        {value:"1",name:"周一"},
        {value:"2",name:"周二"},
        {value:"3",name:"周三"},
        {value:"4",name:"周四"},
        {value:"5",name:"周五"},
        {value:"6",name:"周六"},
        {value:"7",name:"周日"},
      ], //每周重复 选择项
    }
  },
  mounted(){
    this.init();
  },
  methods:{
    init(){
      var data = {
        token: this.token,
        app_id: this.app_id
      }
      return false;
      // getFamily(data).then(res => {
      //   if(res.code == 200){
      //     console.log(res.data)
      //     this.formData = Object.assign({},res.data);
      //     this.formData.is_code = this.formData.is_code == 1? true:false;
      //     this.formData.is_open = this.formData.is_open == 1? true:false;
      //     delete this.formData.app_id;
      //     delete this.formData.create_time;
      //   }else{
      //     this.$message(res.msg);
      //   }
      // })
    },
    save(){
      var data = Object.assign({},this.formData);
      data.token = this.token;
      data.app_id = this.app_id;
      data.is_code = data.is_code? 1:0;
      data.is_open = data.is_open? 1:0;
      console.log(data);
      return false;
      // setFamily(data).then(res => {
      //   if(res.code == 200){
      //     this.$message({
      //       type: "success",
      //       message: "保存成功"
      //     })
      //     this.init();
      //   }else{
      //     this.$message(res.msg);
      //   }
      // })
    }
  }
}
</script>
<style lang="scss" scoped>
.bodycontent{
  border: 20px solid #f0f2f5;
  height: 100%;
  overflow: auto;
  padding:0 18px;
  .page_title{
    height: 60px;
    line-height: 60px;
    font-size: 18px;
    border-bottom: 1px dashed #eee;
  }
  .page_form{
    padding-top: 30px;
    .input_box{
      width: 150px;
      margin-right: 10px;
    }
    .input_box_small{
      width: 50px;
    }
    .form_info_text{
      color: #aaa;
    }
  }
  .save_button{
    margin-top: 25px;
    padding-left:100px;
    margin-bottom: 50px;
    
  }
  .open_box{
    display: flex;
    height: 32px;
    line-height: 32px;
    margin-bottom: 18px;
    .open_label{
      width: 120px;
      padding-right:12px;
      color: #606266;
      font-size: 14px;
      text-align: right;
    }
  }
  .radio_name{
    margin-right:15px;
  }
  .dblock{
    display: block;
    margin-top: 12px;
  }
  .week_select{
    display: inline-block;
    vertical-align: top;
    margin-right: 10px;
  }
}
</style>